export default __webpack_public_path__ + "static/media/legal-2.43fb37b1.jpg";